import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ClubSearchPage } from '@/features/search/pages/club-search-page/page';
import { redirectUnauthenticated } from '@/shared/helper';

export const Route = createFileRoute('/clubOwner/$id/_club/search/')({
  // ✅ Добавляем валидацию параметров search
  validateSearch: z.object({
    citizenships: z.string().optional() // <- если фильтр строкой
  }),

  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ClubSearchPage
});
